import React from "react";
import { Claims, useUsuario } from "../../providers/usuarioProvider";

type Props = {
  match: (claims?: Claims) => boolean;
};

export default function PermissaoDisplay({
  match,
  children,
}: React.PropsWithChildren<Props>) {
  const { isLoading, claims } = useUsuario();
  if (isLoading) return <></>;
  else if (match(claims)) return <>{children}</>;
  else return <></>;
}
